import React, { useRef } from "react";
import classNames from "classnames";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Currency } from "@app/types/currencies";
import { CurrencyView } from "../../../currency-view/CurrencyView";

type Props = {
  currency: Currency;
  className?: string;
  onCurrencyChange: React.MouseEventHandler;
};

export const CurrencyToggle: React.FC<Props> = ({
  currency,
  className,
  onCurrencyChange,
}) => {
  const ref = useRef<HTMLUListElement>(null);

  return (
    <div
      className={classNames(
        "dropdown dropdown-end dropdown-bottom cursor-pointer",
        className,
      )}
      tabIndex={0}
      role="button"
    >
      <div className="flex flex-row items-center gap-2">
        <CurrencyView currency={currency} />

        <FontAwesomeIcon icon={faChevronDown} width={14} />
      </div>

      <ul
        ref={ref}
        tabIndex={0}
        className="menu dropdown-content z-[1] w-40 translate-y-1 rounded-3xl bg-divider p-0 shadow"
      >
        {Object.entries(Currency)
          .filter(([, value]) => value !== currency)
          .map(([key, value]) => (
            <li
              key={key}
              data-value={value}
              onClick={(event) => {
                onCurrencyChange(event);

                ref.current?.blur();
              }}
            >
              <CurrencyView currency={value} />
            </li>
          ))}
      </ul>
    </div>
  );
};
